import { format } from "date-fns";

import { Chip } from "@mui/material";
import { DataGridPro, GridRenderCellParams } from "@mui/x-data-grid-pro";

import { CompanyType } from "@interfaces/company.type";

const columns = [
  {
    field: "date",
    flex: 1,
    headerName: "Date",
    valueFormatter: (value: string) => format(value, "MM/dd/yyyy"),
    valueGetter: (value: string) => new Date(value),
  },
  {
    field: "amount",
    flex: 1,
    headerName: "Amount",
    renderCell: (parameters: GridRenderCellParams) => {
      // Check if amount is missing, display Chip if true
      const amount = parameters.value;
      return amount ? (
        `${parameters.row.currency}${amount}` // Show amount with currency
      ) : (
        <Chip color="default" label="Private" size="small" />
      ); // Show "Private" chip if no amount
    },
  },
  { field: "type", flex: 1, headerName: "Type" },
  { field: "investors", flex: 2, headerName: "Investors" },
];

interface IFundingEventsTableProperties {
  fundingEvents: CompanyType["fundingEvents"];
}

export default function FundingEventsTable({ fundingEvents }: IFundingEventsTableProperties) {
  const rows = fundingEvents.map((event: any, index: any) => ({
    amount: event.amount || null,
    currency: event.amount ? event.currency : "",
    date: format(new Date(event?.date ?? ""), "MM/dd/yyyy"),
    id: index,
    investors: event.investors,
    type: event.type,
  }));

  return (
    <div style={{ height: "100%", overflowX: "auto", width: "100%" }}>
      <DataGridPro
        columns={columns}
        rows={rows}
        sortModel={[
          {
            field: "date",
            sort: "desc",
          },
        ]}
      />
    </div>
  );
}
